import { connect } from 'react-redux';
import { fetchWrapupsIfNeeded, toggleBundlesModal, createBundleRequest,
  uploadFilesRequest } from 'project/ducks/wrapup';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import UploadBundlesModal from 'project/components/wrapup/upload_bundles_modal';

export default connect(() => ({}), {
  onClose: toggleBundlesModal,
  createBundleRequest,
  uploadFilesRequest,
  fetchWrapupsIfNeeded,
  fetchMessagesIfNeeded
})(UploadBundlesModal);



// WEBPACK FOOTER //
// ./project/containers/wrapup/upload_bundles_modal.js